export const COMPANY_NAME = 'name';
export const COMPANY_ID = 'id';
export const KIOSK_ID = 'kioskId';

export default {
  COMPANY_NAME,
  COMPANY_ID,
  KIOSK_ID,
};
